import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { GoogleAnalytics } from "@/components/GoogleAnalytics";
import { initAnalytics } from "@/lib/analytics";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Disclaimer from "@/pages/Disclaimer";
import InvoiceDiscounting from "@/pages/InvoiceDiscounting";
import Track from "@/pages/Track";
import Insights from "@/pages/Insights";
import Partners from "@/pages/Partners";
import Team from "@/pages/Team";

initAnalytics();

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, duration: 1.2 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <BrowserRouter>
        <GoogleAnalytics />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/invoice-discounting" element={<InvoiceDiscounting />} />
          <Route path="/track" element={<Track />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/team" element={<Team />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </>
  );
}
